<template>
  <div class="container pap-form">
    <div v-if="showPasswordChangeResult" class="mb-3">
      <AlertCard
        :type="resultType"
        :header="resultHeader"
        :message="resultMessage"
      />
    </div>

    <FormReauth
      v-if="showReauthForm"
      formTitle="Change Password: Verify Credentials"
      actionStatement="change your password"
      @reauth-validated="onValidReauth($event)"
    />

    <Form
      v-if="showChangePasswordForm"
      key="changePassword"
      :data="changePasswordForm"
      @form-validated="processChangePassword($event)"
    >
      <template v-slot:topText>
        <p class="pap-form__text">Please enter and submit your new password.</p>
      </template>
    </Form>
  </div>
</template>

<script>
import FormReauth from '@/components/form/FormReauth';
import Form from '@/components/form/Form';
import AlertCard from '@/components/notifications/AlertCard';

import { SignUp } from '@/models/Signup';

import { mapGetters } from 'vuex';

export default {
  name: 'PageChangePassword',
  components: {
    FormReauth,
    Form,
    AlertCard,
  },
  data: function () {
    return {
      showPasswordChangeResult: false,
      showReauthForm: true,
      resultType: '',
      resultSuccessMsg: '',
      resultErrorMsg: '',
      // reauthForm: this.reauthFormData(),
      changePasswordForm: this.changePasswordFormData(),
    };
  },

  computed: {
    ...mapGetters('auth', ['authUser']),

    showChangePasswordForm: function () {
      return !this.showPasswordChangeResult && !this.showReauthForm;
    },

    resultHeader: function () {
      if (this.resultType === 'success') {
        return 'Success!';
      }
      if (this.resultType === 'error') {
        return 'There was a problem...';
      }
      return '';
    },
    resultMessage: function () {
      return this.resultErrorMsg ? this.resultErrorMsg : this.resultSuccessMsg;
    },
  },

  methods: {
    // Create and return the 'change password' form data obj for the corresponding Form component
    changePasswordFormData: function () {
      var formData = {
        formTitle: 'Change Your Password',
        headerIconClass: 'fas fa-key mr-2',
        // headerIconClass: 'far fa-envelope mr-2',
        orderedFields: ['password', 'confirmPassword'],
        submitButtonText: 'Save',
        model: SignUp,
        fields: {
          password: {
            type: 'password',
            label: 'New Password',
            placeholder: 'New password',
            maxLength: SignUp.getPropTruncateLength('password'),
            value: '',
            valid: null,
            errorMsg: '',
          },
          confirmPassword: {
            type: 'password',
            label: 'Confirm New Password',
            placeholder: 'Confirm new password',
            maxLength: SignUp.getPropTruncateLength('confirmPassword'),
            value: '',
            valid: null,
            errorMsg: '',
          },
        },
      };
      return formData;
    },

    onValidReauth: function () {
      this.showReauthForm = false;
    },

    processChangePassword: async function (formData) {
      if (formData) {
        try {
          await this.$fapi.setUserPassword(formData.password);

          // Set user's new email in state; it's a reactive property, so doing this will automatically update the
          // email shown in the welcome bar.
          //   this.$store.dispatch('auth/setAuthUserEmail', formData.email);

          this.resultType = 'success';
          this.resultSuccessMsg = `Your new password was saved. Use this new password whenever you log in.`;
        } catch (err) {
          this.resultType = 'error';
          // If user enters an email that's in use by another account, this is the error message thrown:
          // The email address is already in use by another account.
          // For security reasons, don't want to show that. So, set error message to something generic.
          this.resultErrorMsg =
            'Your new password was not saved: ' + err.message;
          //   this.resultErrorMsg =
          //     'The new email address you just entered was not saved. Your account is still set to your current email address: ' +
          //     this.authUser.email;
        }
        this.showPasswordChangeResult = true;
      }
    },
  },
};
</script>

<style>
</style>